package hk.com.vr360_demo2.webapp.component.previewer

import emotion.react.css
import hk.com.vr360_demo2.webapp.component.SingleHotspotScenePanoramaPreview
import hk.com.vr360_demo2.webapp.component.baseview.DefaultScreenUI
import kotlin.js.js
import react.CSSProperties
import react.FC
import react.Props
import react.dom.html.ReactHTML.div
import react.useEffect
import react.useState
import web.cssom.pct
import web.cssom.vh

external interface PreviewerProps : Props {
    var component: PreviewerComponent
}

val PreviewerScreen = FC<PreviewerProps> { props ->
    val (uiState, setUiState) = useState(PreviewerState())

    useEffect {
        props.component.state.collect { setUiState(it) }
    }

    val scene = uiState.scene

    DefaultScreenUI {
        hasReady = scene != null
        progressBarState = uiState.progressBarState
        networkState = uiState.networkState
        errors = props.component.errors
        emptyMessage = "缺少 url，無法預覽全景圖"
        onTryAgain = {}

        if (scene != null) {
            div {
                css {
                    width = 100.pct
                    height = 100.vh
                    asDynamic()["@supports (height: 100dvh)"] =
                        js("{}").unsafeCast<CSSProperties>().apply {
                            asDynamic().height = "100dvh"
                        }
                }

                SingleHotspotScenePanoramaPreview {
                    this.scene = scene
                    this.linkHotspot = null
                    this.autorotateEnabled = uiState.autorotateEnabled
                }
            }
        }
    }
}
